/* eslint-disable react-hooks/exhaustive-deps */
import { Container } from "@material-ui/core";
import React, { useEffect } from "react";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import { useParams } from "react-router";
import ThemeTable from "../../../../components/Table/ThemeTable";
import { getEmployee } from "../../../../services/apiservices/employee";
import { getProductDetails, getSettings } from "../../../../services/apiservices/settings";
import { CustomTooltip } from "../../../../components/DialogComponent/SupplyDataDialog";
import { formatTimestamp } from "../../../../services/helpers";


const ManageCompanyDetails = () => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [empData, setEmpData] = React.useState();
    const [subscriptionData, setSubcriptionData] = React.useState();
    const [productData, setProductData] = React.useState();
    const [finaleData, setFinalData] = React.useState([]);
    const { companyId } = useParams();

    const Columns = [
        {
            id: "companyName",
            numeric: false,
            disablePadding: true,
            label: "Company Name",
            isSortable: true,
        },
        {
            id: "plan",
            numeric: false,
            disablePadding: true,
            label: "Plan Name",
            isSortable: true,
        },
        {
            id: "price",
            numeric: false,
            disablePadding: true,
            label: "Price",
            isSortable: true,
        },
        {
            id: "features",
            numeric: false,
            disablePadding: true,
            label: "Features",
            isSortable: true,
        },
        {
            id: "planStart",
            numeric: false,
            disablePadding: true,
            label: "Plan Start Date",
            isSortable: true,
        },
        {
            id: "planEnd",
            numeric: false,
            disablePadding: true,
            label: "Plan End Date",
            isSortable: true,
        },
        {
            id: "period",
            numeric: false,
            disablePadding: true,
            label: "Time Period",
            isSortable: true,
        },
        {
            id: "status",
            numeric: false,
            disablePadding: true,
            label: "Status",
            isSortable: true,
        },
    ];

    const formatPrice = (amount, currency, quantity = 1) => {
        if (!amount || !currency) return "";
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency.toUpperCase()
        }).format((amount * quantity) / 100);
    };


    const getCompanyDetails = async () => {
        setIsLoading(true);
        try {
            const [empRes, subRes] = await Promise.all([
                new Promise((resolve) => getEmployee(companyId, resolve)),
                new Promise((resolve) => getSettings('strip_subscription', resolve))
            ]);

            const empData = empRes?.data || null;
            const filteredSubData = subRes?.data?.filter((item) => item.customer === empData?.customer) || [];
            const subcriptionData = filteredSubData.length > 0 ? filteredSubData[0] : null;

            setEmpData(empData);
            setSubcriptionData(filteredSubData);

            let productData = null;
            if (subcriptionData?.plan?.product) {
                 await getProductDetails(subcriptionData?.plan?.product, (res)=>{
                     productData = res?.data || null;
                     setProductData(res?.data);
                 })
            }

            const data = {
                companyName: `${empData.companyName}`,
                plan: subcriptionData?.items?.data?.[0]?.plan?.name,
                status: empData?.subscriptions?.data?.[0]?.status,
                price: formatPrice(subcriptionData?.items?.data?.[0]?.price?.unit_amount, subcriptionData?.items?.data?.[0]?.price?.currency, subcriptionData?.items?.data?.[0]?.quantity),
                features: `(${productData?.features?.length})`,
                planStart: empData?.subscriptions?.data?.[0]?.current_period_start ? formatTimestamp(empData?.subscriptions?.data?.[0]?.current_period_start) : "",
                planEnd: empData?.subscriptions?.data?.[0]?.current_period_end ? formatTimestamp(empData?.subscriptions?.data?.[0]?.current_period_end) : "",
                period: empData?.subscriptions?.data?.[0]?.plan?.interval,
                featuresDetails: productData?.features ? productData?.features : ""
            };

            setFinalData(data);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching company details:", error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getCompanyDetails();
    }, []);

    const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
        switch (hcellItem.id) {
            case "features":
                return (
                    <>
                        <CustomTooltip
                            listData={rcellItem?.featuresDetails}
                            title={`${rcellItem?.features}`}
                        />
                    </>
                )
            default:
                return <p>{rcellItem[hcellItem?.id]} </p>;
        }
    }

    return (
        <Container>
            <PageTitle
                pageTitle={"Manage Company Details"}
                showBreadcrumb={[
                    { label: "Home", to: "/" },
                    { label: "Company", to: "/company" },
                ]}
                BreadCrumbCurrentPageTitle={"Manage Company Details"}
                showLastSeen={true}
            />
            <div className="sectionBox">
                <ThemeTable
                    rows={[finaleData]}
                    headCells={Columns}
                    hidePagination={false}
                    isLoading={isLoading}
                    renderRowCell={renderRowCell}
                />
            </div>
        </Container>
    )
}

export default ManageCompanyDetails;